import { render, staticRenderFns } from "./HorseMovements.vue?vue&type=template&id=799a01dc"
import script from "./HorseMovements.vue?vue&type=script&lang=js"
export * from "./HorseMovements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports